export const ftueQueryString = 'ftue';
export const programIdQueryString = 'program_id';
export const showOverviewQueryString = 'show_overview';
export const packClassQueryString = 'pack_class';
export const errorTitleQueryString = 'error_title';
export const errorBodyQueryString = 'error_body';
export const friendsAndFamilyIdString = 'id';
export const notificationsTypeString = 'type';
export const newAndNoteworthyPack = 'new-noteworthy';
export const forYouPack = 'embeddings-because-you-listened-to';
export const redirectQueryString = 'redirect';
export const gadScoreId = 'gad_score';
export const phqScoreId = 'phq_score';
export const selfHarmScoreId = 'mental_health_answer';
export const selfHarmQuestionId = 'mental_health_hurting';
export const mentalHealthPollId = 'mental_health';
export const mentalHealthRecDefnId = 'mental-health-poll';
export const crisisRecDefnId = 'referral-crisis-response';
export const crisisReferralId = 'crisis-response';
export const calmHealthSupportEmail = 'support@calmhealth.com';
export const calmSupportEmail = 'support@calm.com';
export const ftueFadeInTimeout = 500;
export const GOALS_TOPICS_INFO_VIDEO_ID = 'gtiv';
export const CONDITIONS_INFO_VIDEO_ID = 'civ';
export const SCREENING_INFO_VIDEO_ID = 'siv';
export const STANDALONE_SCREENING_INFO_VIDEO_ID = 'ssiv';
export const INTRO_TO_CARE_PLAN_VIDEO_ID = 'itcpv';
export const PROGRAM_COMPLETION_CELEBRATION_VIDEO_ID = 'pccv';
export const OPT_IN_COOKIE_NAME = 'toic';
export const LOCATION_OVERRIDE_COOKIE_NAME = 'spoof-country';
export const enum RHG_HEADER {
    APP = 'RHG-App',
    APP_APPEND = 'RHG-App-Append',
    TEST_CASE = 'RHG-test-case',
}
export const LANGUAGE_HEADER = 'Accept-Language';
export const DEFAULT_COUNTRY_CODE = 'US';
